import { Button } from "@/components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "@/components/ui/card";
import { Link } from "react-router-dom";

interface Props {
  Quote: {
    id: string;
    status: string;
    quotenumber: string;
    name: string;
    reference: string;
    expirydate: Date;
    totalpriceex: number;
    deliveryamountex: number;
    bdm: {
      id: string;
      firstname: string;
      lastname: string;
      mobile: string;
      phone: string;
      email: string;
    };
  };
}

export default function QuoteListCard({ Quote }: Props) {
  return (
    <Card className="w-[350px]  bg-harvey-black text-white m-y-2">
      <CardHeader className="-mt-4">
        <CardTitle>{Quote.quotenumber}</CardTitle>
        <CardDescription className="text-white italic">
          Please double check before approving
        </CardDescription>
      </CardHeader>
      <CardContent className="-mt-4">
        <div className="flex items-center space-x-4 -mb-1">
          {/* <Avatar className="justify-center ">
            <BookOpenCheck size={60} color="#f5f5f5" strokeWidth={1} />
          </Avatar> */}
          <div className="space-y-2">
            <p className="text-sm font-medium leading-none">{Quote.name}</p>

            <p className="text-xs text-muted-foreground text-white">
              You Reference: {Quote.reference}
            </p>
            <p className="text-xs text-muted-foreground text-white">
              Expires On {}
            </p>
            <p className="text-xs text-muted-foreground text-white">
              Total Price Ex: ${Quote.totalpriceex}
            </p>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between -mt-2 -mb-2">
        <Button size="xs" className="bg-green-700 hover:bg-green-900">
          <Link to={`/customer-portal/quotations/?id=${Quote.id}$action=approve`}>
            Approve
          </Link>
        </Button>
        <Button variant="default" size="xs" className="bg-sky-800 hover:bg-sky-950">
          <Link to={`/customer-portal/quotations/?id=${Quote.id}`}>View</Link>
        </Button>
        <Button variant="destructive" size="xs" className="hover:bg-red-900">
          <Link to={`/customer-portal/quotations/?id=${Quote.id}&action=decline`}>
            Decline
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
}
